import React, {useState} from 'react';

const ScoreResult = ({results}) => {
    let capture = [];
    results.map(item => {
        if (item.item === 'sistolica_bi') {
            capture.push(`${item.value}/`)
        }
        if ( item.item === 'diastolica_bi' ){
            capture.push(item.value)
        }
    });
    return ( 
        (results.map(result => {
            if (result.item === 'glicemia'){
                return (
                    <div key={result.item}>
                        {result.value} <small>Mg/Dl</small>
                    </div>
                )
            }
            if (result.item === 'imc'){
                return (
                    <div key={result.item}>
                        {result.value} <small>Kg/m2</small>
                    </div>
                )
            }
            if (result.item === 'colesterol'){
                return (
                    <div key={result.item}>
                        <small>Colesterol</small> <br/>
                        {result.value} <small>Mg/Dl</small>
                    </div>
                )
            }
            if (result.item === 'trigliceridos'){
                return (
                    <div key={result.item}>
                        <small>Trigliceridos</small> <br/>
                        {result.value} <small>Mg/Dl</small>
                    </div>
                )
            }
            if (result.item === 'sistolica_bi'){
                return (
                    <div className='sist' key={result.item}>
                        {capture.join('')} <small>Mg/Dl</small>
                    </div>
                )
            }
        }))
    );
}
 
export default ScoreResult;